import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateStorageService } from './service/translate-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private translateStorageService: TranslateStorageService,
  ) {
    registerLocaleData(localeDe, 'de');

    const language: string | null =
      this.translateStorageService.getLanguageKey();

    if (language) {
      this.translate.setDefaultLang(language);
      this.translate.use(language);
    } else {
      this.translate.setDefaultLang('de');
      this.translate.use('de');
    }
  }
}
